<template>
  <h2 class="regtitle1"></h2>
  <div class="applycontainer" v-loading="loadingmain">
    <el-row :gutter="30">
      <el-col :span="24" style="padding-left: 42px;">
          <el-tabs v-model="activeName" type="card"  @tab-click="tabsclick">
            <el-tab-pane label="收到待处理" name="page0" class="retainlist">
              <!-- pagers -------------------------------------------- -->
              <el-row gutter="2" style="margin-bottom: 8px;">
                <el-col :span="18">
                  <div style="text-align:left; ">
                <el-button color="#16a951" @click="edit(1,0)" size="small">接受</el-button>
                <el-button color="#c93756" @click="edit(2,0)" size="small">谢绝</el-button>
                <el-button color="#4b5cc4" @click="edit(3,0)" size="small">考虑</el-button>
                <el-button color="#50616d" @click="edit(4,0)" style="display: none;">收藏</el-button>
                <el-button color="#be002f" @click="edit(5,0)" size="small">删除</el-button>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="text-align:right;">
                    <el-pagination style="float: right;" small :current-page="currentpage" background :total="total" :page-size="30" pager-count="5" layout="prev, pager, next" @current-change="pagechange"/>
                  </div>
                </el-col>
              </el-row>
              <!-- pagers -------------------------------------------- -->
              <!-- -------------------------------------------- -->
              <div class="scrollbarbox" :style="'height:'+(boxheight-242)+'px;overflow-y:auto;overflow-x:none;'">
              <div style="width:98%;">
              <el-row gutter="12" v-for="item in listinfo" :key="item.applyid">
                <el-col :span="1" style="padding-top: 22px;">
                  <input type="checkbox" class="pidbox" name="pid" :value="item.applyid" />
                </el-col>
                <el-col :span="2" class="retaincompanylogo" v-if="item.applyresumecontent!=''">
                    <span :class="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender==='男'?'resumegendera':'resumegenderb'">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender }}</span>
                    <img :class="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender==='男'?'bordera':'borderb'" :src="baseurl+'static/resume/'+JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeusersid+'/photo/'+JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeusersid+'.jpg'" onerror="this.src='/images/avatar1.png'" />
                </el-col>
                <el-col :span="18" class="retaininfo" v-if="item.applyresumecontent!=''">
                    <div v-if="item.applyresumecontent!=''">
                      <el-link v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumejobstatus>-1" :underline="false" :href="'/resumeitem?id='+item.applyresumeid" target="_blank">{{item.applyresumename}}</el-link>
                      <el-link v-else :underline="false" target="_blank"><span style="color: red;">{{item.applyresumename}}=======> 已屏蔽</span></el-link>
                      <el-link :underline="false" href="#" class="jobtitle">{{item.applyjobtitle}}</el-link>
                      <span style="font-size: 12px; margin-left: 20px;">{{ item.applydate.replaceAll(/T/ig," ").replaceAll(/Z/ig," ") }}</span>
                    </div>
                  <div v-if="item.applyresumecontent!=''">
                    <span class="infovv">
                      <span>{{ getAge(JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumebirthday) }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeworkage!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeworkage }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschool!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschool }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumespecialty!=''">{{JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumespecialty}}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschoolage!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschoolage }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumesalary!=''" style="color: crimson;">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumesalary }}</span>
                    </span>
                  </div>
                </el-col>
                <el-col :span="3" style="text-align: center;">
                  <span class="statusbox">
                    <el-image src="/images/daichuli.png" v-if="item.applystatus===0" />
                    <el-image src="/images/jieshou.png" v-else-if="item.applystatus===1" />
                    <el-image src="/images/kaolv.png" v-else-if="item.applystatus===2" />
                    <el-image src="/images/jujue.png" v-else/>
                  </span>
                  <el-button  color="#000000" size="small" round style="font-size:12px;" @click="chatopen(item.applyresumeid)"><el-icon style="margin-right:6px;"><ChatDotRound /></el-icon>沟通</el-button>
                </el-col>
                  <el-divider />
              </el-row>
              </div>
              </div>
              <!-- -------------------------------------------- -->
            </el-tab-pane>
            <el-tab-pane label="收到已接受" name="page1" class="retainlist">
              <!-- pagers -------------------------------------------- -->
              <el-row gutter="2" style="margin-bottom: 8px;">
                <el-col :span="18">
                  <div style="text-align:left; ">
                <el-button color="#16a951" @click="edit(1,0)" size="small">接受</el-button>
                <el-button color="#c93756" @click="edit(2,0)" size="small">谢绝</el-button>
                <el-button color="#4b5cc4" @click="edit(3,0)" size="small">考虑</el-button>
                <el-button color="#50616d" @click="edit(4,0)" style="display: none;">收藏</el-button>
                <el-button color="#be002f" @click="edit(5,0)" size="small">删除</el-button>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="text-align:right;">
                    <el-pagination style="float: right;" small :current-page="currentpage" background :total="total" :page-size="30" pager-count="5" layout="prev, pager, next" @current-change="pagechange"/>
                  </div>
                </el-col>
              </el-row>
              <!-- pagers -------------------------------------------- -->
              <!-- -------------------------------------------- -->
              <div class="scrollbarbox" :style="'height:'+(boxheight-242)+'px;overflow-y:auto;overflow-x:none;'">
              <div style="width:98%;">
              <el-row gutter="12" v-for="item in listinfo" :key="item.applyid">
                <el-col :span="1" style="padding-top: 22px;">
                  <input type="checkbox" class="pidbox" name="pid" :value="item.applyid" />
                </el-col>
                <el-col :span="2" class="retaincompanylogo" v-if="item.applyresumecontent!=''">
                    <span :class="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender==='男'?'resumegendera':'resumegenderb'">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender }}</span>
                    <img :class="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender==='男'?'bordera':'borderb'" :src="baseurl+'static/resume/'+JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeusersid+'/photo/'+JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeusersid+'.jpg'" onerror="this.src='/images/avatar1.png'" />
                </el-col>
                <el-col :span="18" class="retaininfo" v-if="item.applyresumecontent!=''">
                    <div v-if="item.applyresumecontent!=''">
                      <el-link v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumejobstatus>-1" :underline="false" :href="'/resumeitem?id='+item.applyresumeid" target="_blank">{{item.applyresumename}}</el-link>
                      <el-link v-else :underline="false" target="_blank"><span style="color: red;">{{item.applyresumename}}=======> 已屏蔽</span></el-link>
                      <el-link :underline="false" href="#" class="jobtitle">{{item.applyjobtitle}}</el-link>
                      <span style="font-size: 12px; margin-left: 20px;">{{ item.applydate.replaceAll(/T/ig," ").replaceAll(/Z/ig," ") }}</span>
                    </div>
                  <div v-if="item.applyresumecontent!=''">
                    <span class="infovv">
                      <span>{{ getAge(JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumebirthday) }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeworkage!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeworkage }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschool!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschool }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumespecialty!=''">{{JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumespecialty}}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschoolage!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschoolage }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumesalary!=''" style="color: crimson;">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumesalary }}</span>
                    </span>
                  </div>
                </el-col>
                <el-col :span="3" style="text-align: center;">
                  <span class="statusbox">
                    <el-image src="/images/daichuli.png" v-if="item.applystatus===0" />
                    <el-image src="/images/jieshou.png" v-else-if="item.applystatus===1" />
                    <el-image src="/images/kaolv.png" v-else-if="item.applystatus===2" />
                    <el-image src="/images/jujue.png" v-else/>
                  </span>
                  <el-button  color="#000000" size="small" round style="font-size:12px;" @click="chatopen(item.applyresumeid)"><el-icon style="margin-right:6px;"><ChatDotRound /></el-icon>沟通</el-button>
                </el-col>
                  <el-divider />
              </el-row>
              </div>
              </div>
              <!-- -------------------------------------------- -->
            </el-tab-pane>
            <el-tab-pane label="收到考虑中" name="page2" class="retainlist">
              <!-- pagers -------------------------------------------- -->
              <el-row gutter="2" style="margin-bottom: 8px;">
                <el-col :span="18">
                  <div style="text-align:left; ">
                <el-button color="#16a951" @click="edit(1,0)" size="small">接受</el-button>
                <el-button color="#c93756" @click="edit(2,0)" size="small">谢绝</el-button>
                <el-button color="#4b5cc4" @click="edit(3,0)" size="small">考虑</el-button>
                <el-button color="#50616d" @click="edit(4,0)" style="display: none;">收藏</el-button>
                <el-button color="#be002f" @click="edit(5,0)" size="small">删除</el-button>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="text-align:right;">
                    <el-pagination style="float: right;" small :current-page="currentpage" background :total="total" :page-size="30" pager-count="5" layout="prev, pager, next" @current-change="pagechange"/>
                  </div>
                </el-col>
              </el-row>
              <!-- pagers -------------------------------------------- -->
              <!-- -------------------------------------------- -->
              <div class="scrollbarbox" :style="'height:'+(boxheight-242)+'px;overflow-y:auto;overflow-x:none;'">
              <div style="width:98%;">
              <el-row gutter="12" v-for="item in listinfo" :key="item.applyid">
                <el-col :span="1" style="padding-top: 22px;">
                  <input type="checkbox" class="pidbox" name="pid" :value="item.applyid" />
                </el-col>
                <el-col :span="2" class="retaincompanylogo" v-if="item.applyresumecontent!=''">
                    <span :class="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender==='男'?'resumegendera':'resumegenderb'">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender }}</span>
                    <img :class="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender==='男'?'bordera':'borderb'" :src="baseurl+'static/resume/'+JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeusersid+'/photo/'+JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeusersid+'.jpg'" onerror="this.src='/images/avatar1.png'" />
                </el-col>
                <el-col :span="18" class="retaininfo" v-if="item.applyresumecontent!=''">
                    <div v-if="item.applyresumecontent!=''">
                      <el-link v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumejobstatus>-1" :underline="false" :href="'/resumeitem?id='+item.applyresumeid" target="_blank">{{item.applyresumename}}</el-link>
                      <el-link v-else :underline="false" target="_blank"><span style="color: red;">{{item.applyresumename}}=======> 已屏蔽</span></el-link>
                      <el-link :underline="false" href="#" class="jobtitle">{{item.applyjobtitle}}</el-link>
                      <span style="font-size: 12px; margin-left: 20px;">{{ item.applydate.replaceAll(/T/ig," ").replaceAll(/Z/ig," ") }}</span>
                    </div>
                  <div v-if="item.applyresumecontent!=''">
                    <span class="infovv">
                      <span>{{ getAge(JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumebirthday) }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeworkage!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeworkage }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschool!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschool }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumespecialty!=''">{{JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumespecialty}}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschoolage!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschoolage }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumesalary!=''" style="color: crimson;">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumesalary }}</span>
                    </span>
                  </div>
                </el-col>
                <el-col :span="3" style="text-align: center;">
                  <span class="statusbox">
                    <el-image src="/images/daichuli.png" v-if="item.applystatus===0" />
                    <el-image src="/images/jieshou.png" v-else-if="item.applystatus===1" />
                    <el-image src="/images/kaolv.png" v-else-if="item.applystatus===2" />
                    <el-image src="/images/jujue.png" v-else/>
                  </span>
                  <el-button  color="#000000" size="small" round style="font-size:12px;" @click="chatopen(item.applyresumeid)"><el-icon style="margin-right:6px;"><ChatDotRound /></el-icon>沟通</el-button>
                </el-col>
                  <el-divider />
              </el-row>
              </div>
              </div>
              <!-- -------------------------------------------- -->
            </el-tab-pane>
            <el-tab-pane label="收到已拒绝" name="page3" class="retainlist">
              <!-- pagers -------------------------------------------- -->
              <el-row gutter="2" style="margin-bottom: 8px;">
                <el-col :span="18">
                  <div style="text-align:left; ">
                <el-button color="#16a951" @click="edit(1,0)" size="small">接受</el-button>
                <el-button color="#c93756" @click="edit(2,0)" size="small">谢绝</el-button>
                <el-button color="#4b5cc4" @click="edit(3,0)" size="small">考虑</el-button>
                <el-button color="#50616d" @click="edit(4,0)" style="display: none;">收藏</el-button>
                <el-button color="#be002f" @click="edit(5,0)" size="small">删除</el-button>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div style="text-align:right;">
                    <el-pagination style="float: right;" small :current-page="currentpage" background :total="total" :page-size="12" pager-count="5" layout="prev, pager, next" @current-change="pagechange"/>
                  </div>
                </el-col>
              </el-row>
              <!-- pagers -------------------------------------------- -->
              <!-- -------------------------------------------- -->
              <div class="scrollbarbox" :style="'height:'+(boxheight-242)+'px;overflow-y:auto;overflow-x:none;'">
              <div style="width:98%;">
              <el-row gutter="12" v-for="item in listinfo" :key="item.applyid">
                <el-col :span="1" style="padding-top: 22px;">
                  <input type="checkbox" class="pidbox" name="pid" :value="item.applyid" />
                </el-col>
                <el-col :span="2" class="retaincompanylogo" v-if="item.applyresumecontent!=''">
                    <span :class="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender==='男'?'resumegendera':'resumegenderb'">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender }}</span>
                    <img :class="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumegender==='男'?'bordera':'borderb'" :src="baseurl+'static/resume/'+JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeusersid+'/photo/'+JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeusersid+'.jpg'" onerror="this.src='/images/avatar1.png'" />
                </el-col>
                <el-col :span="18" class="retaininfo" v-if="item.applyresumecontent!=''">
                    <div v-if="item.applyresumecontent!=''">
                      <el-link v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumejobstatus>-1" :underline="false" :href="'/resumeitem?id='+item.applyresumeid" target="_blank">{{item.applyresumename}}</el-link>
                      <el-link v-else :underline="false" target="_blank"><span style="color: red;">{{item.applyresumename}}=======> 已屏蔽</span></el-link>
                      <el-link :underline="false" href="#" class="jobtitle">{{item.applyjobtitle}}</el-link>
                      <span style="font-size: 12px; margin-left: 20px;">{{ item.applydate.replaceAll(/T/ig," ").replaceAll(/Z/ig," ") }}</span>
                    </div>
                  <div v-if="item.applyresumecontent!=''">
                    <span class="infovv">
                      <span>{{ getAge(JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumebirthday) }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeworkage!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeworkage }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschool!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschool }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumespecialty!=''">{{JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumespecialty}}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschoolage!=''">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumeschoolage }}<el-divider direction="vertical" /></span>
                      <span v-if="JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumesalary!=''" style="color: crimson;">{{ JSON.parse(item.applyresumecontent.replace(/\n/g, '').replace(/\r/g, '')).resumesalary }}</span>
                    </span>
                  </div>
                </el-col>
                <el-col :span="3" style="text-align: center;">
                  <span class="statusbox">
                    <el-image src="/images/daichuli.png" v-if="item.applystatus===0" />
                    <el-image src="/images/jieshou.png" v-else-if="item.applystatus===1" />
                    <el-image src="/images/kaolv.png" v-else-if="item.applystatus===2" />
                    <el-image src="/images/jujue.png" v-else/>
                  </span>
                  <el-button  color="#000000" size="small" round style="font-size:12px;" @click="chatopen(item.applyresumeid)"><el-icon style="margin-right:6px;"><ChatDotRound /></el-icon>沟通</el-button>
                </el-col>
                  <el-divider />
              </el-row>
              </div>
              </div>
              <!-- -------------------------------------------- -->
            </el-tab-pane>
      </el-tabs>
    </el-col>
    </el-row>
  </div>
<!-- chat_box -------------------------------------- -->
<div :style="'position:fixed;z-index:999;bottom:0;right:0;background-color:#ffffff;width:568px;height:528px;padding:2px;display:'+drawer">
  <div style="font-size: 12px;line-height: 22px;" @click="drawer='none'"><el-button  color="#c93756" size="small" round style="font-size:10px;margin-left: 498px;" >关闭</el-button>
  </div>
  <iframe id="iframe" :src="iframeSrc" :style="'height:'+boxheight+'px;width:100%;min-height:618px;background-color:#f0f0f0;'" frameborder="0"></iframe>
</div>
<!-- chat_box -------------------------------------- -->
</template>

<script>
import { rapplys, applyedit } from '@/api/user'
import timehelp from '@/utils/timehelp'
export default {
  name: 'applyIndex',
  components: {},
  data () {
    return {
      loadingmain: true,
      boxheight: 518,
      drawer: 'none',
      iframeSrc: '',
      activeName: 'page0',
      total: 0,
      currentpage: 1,
      listinfo: [],
      at: 0 // 0--》处理待  1--》已接受 2--》考虑中  3--》已拒绝
    }
  },
  created () {
    if (this.$route.query.t != null) {
      const tt = this.$route.query.t
      // alert(tt)
      if (tt === '0') {
        this.at = 0
        this.activeName = 'page0'
      } else if (tt === '1') {
        this.at = 1
        this.activeName = 'page1'
      } else if (tt === '2') {
        this.at = 2
        this.activeName = 'page2'
      } else if (tt === '3') {
        this.at = 3
        this.activeName = 'page3'
      }
    }
    this.boxheight = document.documentElement.clientHeight
    this.getlist(this.currentpage)
  },
  methods: {
    getlist () {
      this.loadingmain = true
      rapplys(this.currentpage, this.at).then(res => {
        if (res.data.resultbody.resultlist != null) {
          if (this.currentpage === 1) {
            this.total = res.data.resultbody.total
          }
          this.listinfo = res.data.resultbody.resultlist
        }
        setTimeout(() => { this.loadingmain = false }, 300)
      })
    },
    pagechange (p) {
      if (this.page !== p) {
        this.currentpage = p
        this.getlist(p)
      }
    },
    edit (t, v) {
      const idlist = []
      const arr = document.getElementsByName('pid')
      // alert(JSON.stringify(arr))
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          idlist.push(arr[i].value)
        }
      }
      if (v > 0) {
        idlist.push(v)
      }
      if (idlist.length > 0) {
        applyedit(idlist.toString(), t).then(res => {
          if (res.data.status === 200) {
            this.loading = false
            this.$message({
              message: '操作成功！',
              type: 'success'
            })
            for (let i = 0; i < arr.length; i++) {
              arr[i].checked = false
            }
            this.getlist()
          } else {
            this.$message({
              message: '::>_<:: 出错了！联系一下管客服吧！(' + res.data.message + ')',
              type: 'error'
            })
          }
        }).catch(res => {
          this.$message({
            message: '::>_<:: 出错了！联系一下管客服吧！',
            type: 'error'
          })
        })
      } else {
        alert('(*^__^*)选择需要操作的数据!')
      }
    },
    getAge (vv) {
      return timehelp.getAge(vv)
    },
    chatopen (id) {
      this.drawer = true
      this.iframeSrc = '/chats?id=' + id
    },
    tabsclick (v) {
      this.currentpage = 1
      if (v.props.name === 'page1') {
        this.at = 1
      } else if (v.props.name === 'page2') {
        this.at = 2
      } else if (v.props.name === 'page3') {
        this.at = 3
      } else {
        this.at = 0
      }
      this.listinfo = []
      this.getlist()
    }
  }
}
</script>

<style lang="less" scoped>
.el-checkbox__inner {
  border: 1px solid #000 !important;
}

.statusbox{
    .el-image {width:52px;height:52px;}
}

.pidbox{margin-right: 8px;}
.resumegendera{position:absolute;top:2px;left:98px;width:16px;height: 16px;background-color: #003399; color: #ffffff; border-radius: 10px; font-size: 10px; padding:2px; text-align: center;line-height: 16px;}
.resumegenderb{position:absolute;top:2px;left:98px;width:16px;height: 16px;background-color: #FF0066; color: #ffffff; border-radius: 10px; font-size: 10px; padding:2px; text-align: center;line-height: 16px;}
.bordera{border-width: 2px;border-color: #003399; border-style: solid;width:58px;height:58px;border-radius: 58px;}
.borderb{border-width: 2px;border-color: #FF0066; border-style: solid;width:58px;height:58px;border-radius: 58px;}
.titlea{
  text-align: left;padding-left: 12px;font-size: 16px;margin-top: 2px; margin-bottom: 2px;
}
.applycontainer {
  margin-top: 20px;
  border-radius: 0px;
}

.tg{
  height:52px;
  width:52px;
  // font-size: 12px;
  border-width: 0px;margin-right: 20px;
  text-align: center;line-height:14px;
}
.retaincompany {
  font-size: 12px;
  text-align: left;
  line-height: 22px;
  color: #888888;
  .el-link {
    font-size: 14px;
    color: #333333;
  }
}
.resumecompanylogo {
  text-align: left;
  margin-top: 6px;
}
.retainlist
{
  .el-row{ margin-bottom: 8px;padding-left: 12px; padding-right: 12px;}
  .el-divider {
    margin-top:12px;
    margin-bottom: 12px;
  }
}
.retaininfo {
    font-size: 14px;
    text-align: left;
    line-height: 26px;
    color: #888888;
    .el-link {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
  }
  .jobtitle{float:right;color:#555555;font-size: 14px;}
  .el-tag{margin-right: 8px;color: #333333; margin-bottom: 8px;}
  .infovv{color: #333333;}
}
.rightyx {
  margin-left: 12px;
  margin-right:12px;
  text-align: left;
  font-size: 14px;
  color: #777777;
  line-height: 28px;
  .el-row {
    border-bottom-width:1px;
    border-bottom-style: solid;
    border-bottom-color:  #dddfe5;
    padding-top: 2px;
    padding-bottom: 8px;
  }
  .el-tab-pane {
    padding-left: 20px;
    .el-tag { margin-right: 6px; color:#222222;}
  }
}
</style>
